import React from 'react';
import { styled } from '@mui/material';

const Highlight = ({ children }) => <StyledSpan>{children}</StyledSpan>;

export default Highlight;

const StyledSpan = styled('span')(({ theme }) => ({ color: theme.palette.secondary.main }));
